import { Component } from '@angular/core';
import {UserService} from '../../services/user.service';
import {DialogAdapter, DialogParams} from '../../models/dialog-param';
import {GroupService} from '../../services/group.service';

@Component({
  selector: 'app-modal-profile',
  templateUrl: './modal-profile.component.html',
  styleUrls: ['./modal-profile.component.scss'],
  preserveWhitespaces: false
})
export class ModalProfileComponent implements DialogAdapter {
  params: DialogParams;
  prop: any;
  bookCount: string;
  reOpenParam: any;
  g_name: string;

  constructor(private userService: UserService, private groupService: GroupService) {
    this.userService.getBookCount().subscribe((count) => {
      this.bookCount = count.data;
    });
  }

  onModalInit() {
    this.prop = this.params.extraParams.initialValue;
    this.groupService.getAllGroups().subscribe(gr => {
      if (gr) {
       const group = gr.find(item => item.id === this.prop.model.group_id);
       if (group) {
         this.g_name = group.g_name;
       }
      }
    });
    this.reOpenParam = ['Profile', this.prop];
  }

  getPayload() {
    return;
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/modal-profile/modal-profile.component.ts